import {
    getStorageItem,
    setStorageItem,
} from '../../creator-ui/src/components/storage';
import { fetchTaxpayerInformationSummary } from './api/taxpayer-information';

export const getTaxpayerInformationSummaryPromise = (orgId: string) => {
    return new Promise((resolve, reject) => {
        const key = `${orgId}-document-status`;
        const documentRequestStatus = getStorageItem(key);
        if (!documentRequestStatus) {
            fetchTaxpayerInformationSummary(orgId)
                .then((data: any) => {
                    setStorageItem(key, data.documentRequestStatus || 'none');
                    resolve(data.documentRequestStatus || 'none');
                })
                .catch(() => {
                    setStorageItem(key, 'none');
                    reject('none');
                });
        } else {
            resolve(documentRequestStatus);
        }
    });
};
